// Spaltenbreiten und -reihenfolge einer Lead-Liste (Design-Runde 2, Must-have 7): je Nutzer und Liste gespeichert
// (Breiten unter `einstellungen.breiten` der gemerkten Ansicht, Reihenfolge in `spalten`). Gemeinsam für Smart Views
// und die Leads-Liste.
import { useCallback, useMemo } from "react";
import type { AnsichtZugriff } from "../daten/listenAnsichtStore";
import { KONTAKTWEGE, istNameSpalte } from "./listenSpalten";
import { spalteVerschieben } from "../werkzeuge/spalten";

export function useSpaltenLayout(gemerkt: AnsichtZugriff, gezeigt: string[], spaltenSetzen: (keys: string[] | null) => void) {
  const roh = gemerkt.ansicht?.einstellungen?.breiten;
  const breiten = useMemo<Record<string, number>>(() => {
    const aus: Record<string, number> = {};
    if (roh && typeof roh === "object") for (const [k, v] of Object.entries(roh as Record<string, unknown>)) if (typeof v === "number" && v > 0) aus[k] = v;
    return aus;
  }, [roh]);
  const onBreite = useCallback(
    (key: string, px: number | null) => {
      const neu: Record<string, number | null> = { ...breiten };
      neu[key] = px;
      const sauber = Object.fromEntries(Object.entries(neu).filter(([, v]) => v !== null));
      gemerkt.aendern({ einstellungen: { breiten: Object.keys(sauber).length ? sauber : null } });
    },
    [breiten, gemerkt],
  );
  const fest = useMemo(() => new Set(gezeigt.filter((k) => istNameSpalte(k) || k === KONTAKTWEGE)), [gezeigt]);
  const onVerschieben = useCallback(
    (von: string, nach: string) => {
      const neu = spalteVerschieben(gezeigt, von, nach, fest);
      if (neu !== gezeigt) spaltenSetzen(neu);
    },
    [gezeigt, fest, spaltenSetzen],
  );
  return { breiten, onBreite, onVerschieben };
}
